import { differenceInDays, format, isDate, parseISO } from 'date-fns';
import { dDaFormat, dTi4Format } from 'main_consts';
import { getDateDayPlus } from 'main_func';
import { Iobject } from 'main_type';
import { ProviderContext } from 'notistack';

export const dateValue = (a: string, b: string): Date | null => {
  if (a) {
    return b ? parseISO(`${a} ${b}00`) : parseISO(a);
  }
  return null;
};

export const timeValue = (a: string, b: string): Date | null => {
  if (b) {
    return a ? parseISO(`${a} ${b}00`) : parseISO(b);
  }
  return null;
};

// 1. check start < end
// 2. check interval
export const seDateVerify = (
  name: string,
  date: Date | null,
  seStr: [string, string],
  dataTemp: unknown,
  updateData: (x: Iobject) => void,
  enqueueSnackbar: ProviderContext['enqueueSnackbar'],
  interval = 0,
  dateFormat = dDaFormat
): boolean => {
  const data = dataTemp as Iobject<string>;
  const isStart = name === seStr[0];
  const isEnd = name === seStr[1];
  // maybe empty
  const startDate = isStart ? date : parseISO(data[seStr[0]]);
  const endDate = isEnd ? date : parseISO(data[seStr[1]]);

  if (!isDate(startDate) || !isDate(endDate)) {
    return false;
  }

  const startDateD = startDate as Date;
  const endDateD = endDate as Date;
  // check start < end
  if (startDateD > endDateD) {
    if (isStart) {
      updateData({
        [seStr[0]]: format(startDateD, dateFormat),
        [seStr[1]]: getDateDayPlus(interval, startDateD),
      });
    } else if (isEnd) {
      updateData({
        [seStr[0]]: getDateDayPlus(-interval, endDateD),
        [seStr[1]]: format(endDateD, dateFormat),
      });
    }
    enqueueSnackbar('起始日期不得大於結束日期。');
    return false;
  }

  // check interval
  if (interval && differenceInDays(endDateD, startDateD) > interval - 1) {
    if (isStart) {
      updateData({
        [seStr[0]]: format(startDateD, dateFormat),
        [seStr[1]]: getDateDayPlus(interval, startDateD),
      });
    } else if (isEnd) {
      updateData({
        [seStr[0]]: getDateDayPlus(-interval, endDateD),
        [seStr[1]]: format(endDateD, dateFormat),
      });
    }
    enqueueSnackbar(`日期間距不得大於${interval}日。`);
    return false;
  }
  return true;
};

export const seDaTimeVerify = (
  name: string,
  date: Date | null,
  seStr: [[string, string], [string, string]],
  data: unknown,
  updateData: (x: Iobject) => void,
  enqueueSnackbar: ProviderContext['enqueueSnackbar'],
  interval?: number,
  dateFormat = dDaFormat,
  timeFormat = dTi4Format
): boolean => {
  const dataTemp = data as Iobject<string>;
  const dateStr = date ? format(date, dateFormat) : '';
  const isStart = name === seStr[0][0];
  const isEnd = name === seStr[1][0];

  const startDate = dateValue(
    isStart ? dateStr : dataTemp[seStr[0][0]],
    dataTemp[seStr[0][1]]
  );
  const endDate = dateValue(
    isEnd ? dateStr : dataTemp[seStr[1][0]],
    dataTemp[seStr[1][1]]
  );

  // maybe null
  if (!startDate || !endDate) {
    return false;
  }

  // check start < end
  if (startDate > endDate) {
    if (isStart) {
      const startTiStr = format(endDate, timeFormat);
      updateData({
        [seStr[0][0]]: format(startDate, dateFormat),
        [seStr[0][1]]:
          (!interval || interval === 0) &&
          parseISO(dataTemp[seStr[0][1]]) > parseISO(startTiStr)
            ? startTiStr
            : dataTemp[seStr[0][1]],
        [seStr[1][0]]: getDateDayPlus(interval, startDate),
        // [seStr[0][0]]: daFormatTrans(endDateD, dateFormat),
        // [seStr[0][1]]:
        //   (tiFormatTrans(dataTemp[seStr[0][1]] as string, timeFormat) as Date) >
        //   (tiFormatTrans(startTiStr, timeFormat) as Date)
        //     ? startTiStr
        //     : dataTemp[seStr[0][1]],
      });
    } else if (isEnd) {
      const endTiStr = format(startDate, timeFormat);
      updateData({
        [seStr[1][0]]: format(startDate, dateFormat),
        [seStr[1][1]]:
          parseISO(endTiStr) > parseISO(dataTemp[seStr[1][1]] as string)
            ? endTiStr
            : dataTemp[seStr[1][1]],
      });
    }
    enqueueSnackbar('起始日期不得大於結束日期。');
    return false;
  }

  // check interval
  if (interval && differenceInDays(endDate, startDate) > interval - 1) {
    if (isStart) {
      updateData({
        [seStr[0][0]]: format(startDate, dateFormat),
        [seStr[1][0]]: getDateDayPlus(interval, startDate),
      });
    } else if (isEnd) {
      updateData({
        [seStr[0][0]]: getDateDayPlus(-interval, endDate),
        [seStr[1][0]]: format(endDate, dateFormat),
      });
    }
    enqueueSnackbar(`日期間距不得大於${interval}日。`);
    return false;
  }
  return true;
};
